import { render, staticRenderFns } from "./BaseFormFooterActionButtons.vue?vue&type=template&id=6372a5b6&scoped=true&"
import script from "./BaseFormFooterActionButtons.vue?vue&type=script&lang=js&"
export * from "./BaseFormFooterActionButtons.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormFooterActionButtons.vue?vue&type=style&index=0&id=6372a5b6&prod&lang=scss&scoped=true&"
import style1 from "./BaseFormFooterActionButtons.vue?vue&type=style&index=1&id=6372a5b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6372a5b6",
  null
  
)

export default component.exports